import { Pipe, PipeTransform } from '@angular/core';
import {TranslateService} from '../services/translate.service';

@Pipe({
  name: 'translate',
  pure: false
})
export class TranslatePipe implements PipeTransform {

  constructor(private translationService: TranslateService) {}


  transform(value: string, args?: any[]): any {
    return this.translationService.translate(value);
  }

}



// WEBPACK FOOTER //
// D:/Projects/bid/frontend/src/app/shared/pipes/translate.pipe.ts